import React from 'react';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import SupportContent from '../Components/Support/SupportContent';
import $ from 'jquery';

export default function Support() {
  $('.popover').hide();
  sendGAPageview({ hitType: 'pageview', page: '/Support', title: 'Contact' });

  return (
    <React.Fragment>
      <CommonHeader />
      <SupportContent />
    </React.Fragment>
  );
}
